/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type PdpSharedContactDealerButton_user$ref = any;
export type PdpSharedDescriptionAdditionalOptions_user$ref = any;
export type PdpSharedDescriptionAdditionalOptions_user = {
    readonly " $fragmentRefs": PdpSharedContactDealerButton_user$ref;
    readonly " $refType": PdpSharedDescriptionAdditionalOptions_user$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpSharedDescriptionAdditionalOptions_user",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "PdpSharedContactDealerButton_user",
            "args": null
        }
    ]
} as any);
(node as any).hash = '9a4e522019999e9cdb27776300c7c65a';
export default node;
